<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Telas</h2>
          <p>En este apartado se pueden gestionar las telas.</p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de telas</h3>
              <v-server-table
                name="fabrics"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminFabricsEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nueva tela</b-button
                  >

                  <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionadas</b-button
                  >
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.id)"
                    @change="toggleCell($event, props.row.id)"
                  />
                </div>

                <template v-slot:preview="props">
                  <img
                    style="max-height: 100px; max-width: 100px"
                    :src="props.row.icon"
                  />
                </template>

                <template v-slot:code_hex="props">
                  <span>#{{ props.row.code_hex }}</span>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminFabricsEditScreen',
                      params: { id: props.row.id },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Editar</b-button
                  >

                  <b-button
                    @click="removeFabric(props.row.id)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  >
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminFabricsScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.fabricsURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'reference',
          'provider',
          'ref_provider',
          'preview',
          'actions',
        ],
        options: {
          perPage: 100,
          saveState: true,
          sortable: ['reference'],
          headings: {
            reference: 'Nombre de tela',
            ref_provider: 'Ref. proveedor',
            provider: 'Proveedor',
            name_es: 'Nombre',
            preview: 'Vista previa',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeFabric(x);
      });
    },
    removeFabric(id) {
      actions.deleteFabric(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.id)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
